/* GrowJoy Kids progress stays in this browser. No accounts or network requests. */
(function () {
  'use strict';
  var KEY = 'growjoy-kids-progress-v1';
  var IDS = ['plant-hero', 'sunflower-star', 'bug-explorer', 'water-guardian', 'eco-friend', 'soil-scientist'];
  var GAME_BADGES = {
    'build-a-plant': 'plant-hero',
    'garden-rescue': 'bug-explorer',
    'compost-chef': 'eco-friend'
  };
  var CHALLENGES = {"water-cycle-in-your-garden":{"badge":"water-guardian","name":"Water Guardian","questions":[{"question":"Before watering a garden pot, what should you do?","answers":["Add water every time you walk past","Check its moisture and ask what the plant needs","Fill the saucer to the top"],"correct":1,"explanation":"Check first: different plants and conditions need different amounts of water."},{"question":"When a grown-up says the pot needs water, where should you aim?","answers":["Gently at the growing mix near the roots","At a passing butterfly","Only at the outside of the pot"],"correct":0,"explanation":"Water the growing mix gently so water can reach the roots."},{"question":"Your pot has drained, but water is left standing in its saucer. What next?","answers":["Keep adding more water","Block every drainage hole","Ask a grown-up to empty the leftover water"],"correct":2,"explanation":"Do not leave an ordinary garden pot sitting in leftover water."}]},"meet-the-soil-and-the-worms":{"badge":"soil-scientist","name":"Soil Scientist","questions":[{"question":"What can the spaces between soil particles hold?","answers":["Air and water","Only plastic","Nothing useful to roots"],"correct":0,"explanation":"Spaces in soil can hold both air and water."},{"question":"What do earthworms help break down?","answers":["Glass bottles","Decaying plant material","Metal cans"],"correct":1,"explanation":"Earthworms feed on organic material, including decaying plant matter."},{"question":"How should you explore soil with a grown-up?","answers":["Taste it to identify it","Pick up every unknown creature","Observe an adult-approved sample, then wash your hands"],"correct":2,"explanation":"Look carefully, leave unfamiliar creatures alone and wash your hands afterwards."}]}};
  var memory = null;
  var SUNFLOWER_STEPS = ['sown', 'sprouted', 'flowered'];
  function read() {
    try {
      var data = JSON.parse(localStorage.getItem(KEY) || '{}');
      if (data.version === 1 && data.badges && typeof data.badges === 'object') {
        if (!data.games || typeof data.games !== 'object') data.games = {};
        if (!data.activities || typeof data.activities !== 'object') data.activities = {};
        return data;
      }
    } catch (error) {}
    return memory || { version: 1, badges: {}, games: {}, activities: {} };
  }
  function save(data) {
    memory = data;
    try {
      localStorage.setItem(KEY, JSON.stringify(data));
      return true;
    } catch (error) {
      return false;
    }
  }
  function has(id) { return !!read().badges[id]; }
  function paint() {
    var data = read();
    document.querySelectorAll('[data-kids-badge]').forEach(function (node) {
      var id = node.getAttribute('data-kids-badge');
      if (IDS.indexOf(id) < 0) return;
      var earned = !!data.badges[id];
      node.classList.toggle('is-earned', earned);
      node.classList.toggle('is-locked', !earned);
      node.setAttribute('data-earned', earned ? 'true' : 'false');
      var name = node.querySelector('[data-kids-badge-name]');
      var comingSoon = node.getAttribute('data-kids-badge-soon') === 'true';
      if (name) node.setAttribute('aria-label', name.textContent.trim() + (earned ? ', earned' : comingSoon ? ', coming soon' : ', locked'));
      var status = node.querySelector('[data-kids-badge-status]');
      if (status) status.textContent = earned ? 'Earned' : comingSoon ? 'Coming soon' : 'Locked';
      var action = node.querySelector('[data-kids-badge-action-label]');
      if (action) action.textContent = earned ? (action.getAttribute('data-earned-copy') || 'Play again') : action.getAttribute('data-unlock-copy');
    });
    document.querySelectorAll('[data-kids-badge-count]').forEach(function (node) {
      node.textContent = IDS.filter(function (id) { return !!data.badges[id]; }).length + ' of 6 earned';
    });
  }
  function complete(game) {
    var badge = GAME_BADGES[game];
    if (!badge) return { earned: false, saved: false };
    var data = read();
    var first = !data.badges[badge];
    data.badges[badge] = true;
    data.games[game] = true;
    var saved = save(data);
    paint();
    document.dispatchEvent(new CustomEvent('growjoy:progress', { detail: { game: game, badge: badge, first: first, saved: saved } }));
    return { earned: first, saved: saved, badge: badge };
  }
  function sunflowerStep(step, checked) {
    if (SUNFLOWER_STEPS.indexOf(step) < 0) return { saved: false, earned: false };
    var data = read();
    if (!data.activities.sunflower || typeof data.activities.sunflower !== 'object') data.activities.sunflower = {};
    data.activities.sunflower[step] = !!checked;
    var complete = SUNFLOWER_STEPS.every(function (id) { return !!data.activities.sunflower[id]; });
    var first = complete && !data.badges['sunflower-star'];
    if (complete) data.badges['sunflower-star'] = true;
    var saved = save(data);
    paint();
    if (first) document.dispatchEvent(new CustomEvent('growjoy:progress', { detail: { activity: 'grow-a-sunflower', badge: 'sunflower-star', first: true, saved: saved } }));
    return { saved: saved, earned: first, complete: complete };
  }

  function challengeFor(activity) { return Object.prototype.hasOwnProperty.call(CHALLENGES, activity) ? CHALLENGES[activity] : null; }
  function challengeAnswer(activity, index, answer) {
    var challenge = challengeFor(activity);
    if (!challenge || !Number.isInteger(index) || index < 0 || index >= challenge.questions.length || !Number.isInteger(answer) || answer < 0 || answer >= challenge.questions[index].answers.length) return { saved: false, complete: false, correct: false };
    var data = read();
    if (!data.activities.challenges || typeof data.activities.challenges !== 'object') data.activities.challenges = {};
    var progress = data.activities.challenges[activity];
    if (!progress || !Array.isArray(progress.answers)) progress = { answers: [] };
    progress.answers[index] = answer;
    data.activities.challenges[activity] = progress;
    var complete = challenge.questions.every(function (question, i) { return progress.answers[i] === question.correct; });
    var first = complete && !data.badges[challenge.badge];
    if (complete) data.badges[challenge.badge] = true;
    var saved = save(data);
    paint();
    if (first) document.dispatchEvent(new CustomEvent('growjoy:progress', { detail: { activity: activity, badge: challenge.badge, first: true, saved: saved } }));
    return { saved: saved, complete: complete, correct: answer === challenge.questions[index].correct, earned: first, badge: challenge.badge };
  }

  window.GrowJoyBadges = { read: read, has: has, challengeFor: challengeFor, challengeAnswer: challengeAnswer, complete: complete, sunflowerStep: sunflowerStep, paint: paint, ids: IDS.slice() };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();
  window.addEventListener('storage', paint);
})();
